module.exports = __webpack_public_path__ + "site/img/40.49ae1f02.jpg";